import { useTranslation } from "react-i18next";

const WhyChooseUs: React.FC<{}> = () => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "ar";

    const headingSmall = isArabic ? "لماذا تختارنا" : "WHY CHOOSE US";
    const headingBig = isArabic
        ? "شريكك الموثوق للشحن\nالدولي"
        : "Your Trusted Logistics \n Partner for Global Freight";
    const description = isArabic
        ? "عندما يتعلق الأمر بالشحن، فإن الدقة والموثوقية ليست اختيارية — إنها أساسية. إليك لماذا تختار الشركات حول العالمنا لنقل ما يهم:"
        : "When it comes to shipping, precision and reliability aren’t optional—they’re essential. Here’s why businesses around the world choose us to move what matters:";
    const listItems = isArabic
        ? [
              "خبرة شاملة من البداية للنهاية",
              "اتصال سريع وشفاف",
              "خيارات نقل مرنة",
              "تسهيل التخليص الجمركي",
              "موثوقية يمكن قياسها",
          ]
        : [
              "End-to-End Expertise",
              "Fast & Transparent Communication",
              "Flexible Transport Options",
              "Customs Clearance Made Simple",
              "Reliability You Can Measure",
          ];
    const contactTitle = isArabic
        ? "دعنا نتحدث عن شحنتك القادمة"
        : "Let’s talk about your next shipment";
    const getInTouchText = isArabic ? "تواصل معنا" : "GET IN TOUCH";
    const contactUsText = isArabic ? "اتصل بنا" : "CONTACT US";

    return (
        <section
            dir={isArabic ? "rtl" : "ltr"}
            className="w-full bg-slate-50 px-4 py-16 sm:px-6 md:py-24 lg:px-8"
        >
            <div className="mx-auto flex max-w-7xl flex-col overflow-hidden rounded-3xl bg-white shadow-2xl shadow-slate-200/50 md:flex-row">
                {/* Image Section */}
                <div className="relative h-80 w-full overflow-hidden md:h-auto md:w-1/2">
                    <img
                        src="/cargo/whyChooseUs/background.png"
                        alt="Logistics"
                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-80"></div>
                </div>

                {/* Content Section */}
                <div className="flex w-full flex-col justify-center px-6 py-12 md:w-1/2 md:px-12 lg:px-16 xl:px-20">
                    <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-slate-100 px-4 py-1.5 w-fit">
                        <img
                            src="/cargo/herosection/right_arrow_color.svg"
                            alt="arrow"
                            className={`h-4 w-4 ${isArabic ? "rotate-180" : ""}`}
                        />
                        <span className="text-sm font-bold tracking-wider text-[#00B9EC] uppercase">
                            {headingSmall}
                        </span>
                    </div>

                    <h2 className="mb-6 whitespace-pre-line text-3xl font-extrabold leading-tight text-slate-900 sm:text-4xl lg:text-5xl">
                        {headingBig}
                    </h2>

                    <p className="mb-8 font-manrope text-base leading-relaxed text-slate-600 sm:text-lg">
                        {description}
                    </p>

                    <ul className="mb-10 flex flex-col gap-4 font-manrope text-base text-slate-700">
                        {listItems.map((item, idx) => (
                            <li key={idx} className="flex items-center gap-4 transition-transform hover:translate-x-1">
                                <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-emerald-100">
                                    <img
                                        src="/cargo/whyChooseUs/check_icon.svg"
                                        alt="check"
                                        className="h-4 w-4"
                                    />
                                </div>
                                <span className="font-medium">{item}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="border-t border-slate-100 pt-8 mt-auto">
                        <p className="mb-6 font-manrope text-xl font-bold text-slate-900">
                            {contactTitle}
                        </p>

                        <div className="flex flex-col gap-4 sm:flex-row">
                            <button className="group flex w-full items-center justify-center rounded-full bg-[#00B9EC] px-8 py-3.5 text-sm font-semibold text-white shadow-lg shadow-[#00B9EC]/30 transition-all hover:-translate-y-1 hover:bg-[#009fd9] hover:shadow-xl hover:shadow-[#00B9EC]/40 sm:w-auto">
                                <span>{getInTouchText}</span>
                            </button>
                            <button className="group flex w-full items-center justify-center gap-2 rounded-full border-2 border-slate-200 bg-white px-8 py-3.5 text-sm font-semibold text-slate-700 transition-all hover:-translate-y-1 hover:border-slate-900 hover:bg-slate-900 hover:text-white sm:w-auto">
                                <span>{contactUsText}</span>
                                <img
                                    src="/cargo/herosection/right_arrow_color.svg"
                                    alt="arrow"
                                    className={`h-4 w-4 transition-transform group-hover:invert ${
                                        isArabic ? "rotate-180 group-hover:-translate-x-1" : "group-hover:translate-x-1"
                                    }`}
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
